import { Link } from 'react-router';

const PageBreadcrumb = ({
  pageTitle,
  pageSubtitle,
  /** Optional extra next to subtitle (e.g. metadata). */
  pageSubtitleExtra,
  /** Optional node on the same row as the title (e.g. status totals). */
  pageTitleAddon,
  /** Tighter header for dense pages (e.g. QC Task with large table). */
  compact = false,
}) => {
  return (
    <div
      className={
        compact
          ? 'mb-3 flex flex-col gap-1 sm:mb-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-2.5'
          : 'mb-6 flex flex-col gap-1.5 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-3'
      }
    >
      <div className="flex min-w-0 flex-1 flex-col">
        <div
          className={
            compact
              ? 'flex flex-wrap items-center gap-x-2 gap-y-1.5 sm:gap-x-3'
              : 'flex flex-wrap items-center gap-x-3 gap-y-2'
          }
        >
          <h2
            className={
              compact
                ? 'shrink-0 text-lg font-semibold text-gray-800 dark:text-white/90 sm:text-xl'
                : 'shrink-0 text-xl font-semibold text-gray-800 dark:text-white/90'
            }
            x-text="pageName"
          >
            {pageTitle}
          </h2>
          {pageTitleAddon ? (
            <div className="min-w-0 shrink-0">{pageTitleAddon}</div>
          ) : null}
        </div>
        {pageSubtitle || pageSubtitleExtra ? (
          <span
            className={
              compact
                ? 'mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[9px] leading-tight text-gray-500 dark:text-gray-400 sm:text-[10px]'
                : 'mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[10px] leading-snug text-gray-500 dark:text-gray-400'
            }
          >
            {pageSubtitle ? <span>{pageSubtitle}</span> : null}
            {pageSubtitleExtra ? (
              <span className="text-gray-700 dark:text-gray-200">
                {pageSubtitleExtra}
              </span>
            ) : null}
          </span>
        ) : null}
      </div>
      <nav>
        <ol
          className={
            compact
              ? 'flex items-center gap-1 sm:gap-1.5'
              : 'flex items-center gap-1.5'
          }
        >
          <li>
            <Link
              className={
                compact
                  ? 'inline-flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 sm:text-sm'
                  : 'inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400'
              }
              to="/"
            >
              Home
              <svg
                className="stroke-current"
                width={compact ? 14 : 17}
                height={compact ? 14 : 16}
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
                  stroke=""
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </li>
          <li
            className={
              compact
                ? 'text-xs text-gray-800 dark:text-white/90 sm:text-sm'
                : 'text-sm text-gray-800 dark:text-white/90'
            }
          >
            {pageTitle}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default PageBreadcrumb;
